import { ResponsiveMode } from '../../utilities/decorators/withResponsiveMode';
export { ResponsiveMode }; // Exported because the type is an optional prop and not exported otherwise.
/**
 * {@docCategory Dialog}
 */
export var DialogType;
(function (DialogType) {
    /** Standard dialog */
    DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */
    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */
    DialogType[DialogType["close"] = 2] = "close";
})(DialogType || (DialogType = {}));
//# sourceMappingURL=DialogContent.types.js.map